import React, { createContext, useCallback, useContext, useState } from 'react';

type State = {
    loading: boolean;
    showLoading: () => void;
    closeLoading: () => void;
};

type Props = {
    children: React.ReactNode;
};

const LoaderContext = createContext<State>({} as State);

const LoaderProvider: React.FC<Props> = ({ children }) => {
    const [count, setCount] = useState<number>(0);

    const showLoading = useCallback(() => setCount(oldCount => oldCount + 1), []);

    const closeLoading = useCallback(() => setCount(oldCount => oldCount - 1), []);

    return (
        <LoaderContext.Provider
            value={{
                loading: count !== 0,
                showLoading,
                closeLoading
            }}
        >
            {children}
        </LoaderContext.Provider>
    );
};

const useLoader = (): State => {
    const context = useContext(LoaderContext);

    return context;
}

export { LoaderProvider, useLoader };